module.exports = __webpack_public_path__ + "img/er.96ba3a13.svg";